import React from 'react';
import { Input, DatePicker } from 'components/tt-forms/common';
import moment from 'moment';
import {header} from "constants/table";
import {ContainerFileDinhKem} from 'components/upload';
import {validatable} from 'components/utils';

class ThongTinLuatSu extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      soTheLuatSu: '',
      ngayCapTheLuatSu: '',
      noiCapTheLuatSu: '',
      thongTinGioiThieu: '',
      dsGiayUyQuyen: [],
      dsGiayUyQuyenRemove: [],
      dsGiayUyQuyenLuatSu: [],
      received: false
    }
  }

  handleChange(name, e) {
    let state = this.state;
    state[name] = e.target.value;
    this.setState({state});
    this.props.onChange(state);
  }

  handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.setState({...newData});

    this.props.onChange(newData);
  }

  onFileRemove(id, data) {
    this.state.dsGiayUyQuyenRemove = [
      ...this.state.dsGiayUyQuyenRemove,
      id
    ];
    this.state.dsGiayUyQuyen = data;
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  onFileChange(data) {
    let state = this.state;
    state.dsGiayUyQuyen = data;
    this.props.onChange(this.state);
    this.setState(state);
  }

  componentDidMount() {
    let state = this.state;
    if (this.props.data.donId || this.props.data.donCuId && this.props.data.nguoiDuocUyQuyen) {
      state.soTheLuatSu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.soTheLuatSu ? this.props.data.nguoiDuocUyQuyen.soTheLuatSu : '';
      state.ngayCapTheLuatSu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.ngayCapTheLuatSu ? moment(this.props.data.nguoiDuocUyQuyen.ngayCapTheLuatSu) : '';
      state.noiCapTheLuatSu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.noiCapTheLuatSu ? this.props.data.nguoiDuocUyQuyen.noiCapTheLuatSu : '';
      state.thongTinGioiThieu = this.props.data && this.props.data.nguoiDuocUyQuyen && this.props.data.nguoiDuocUyQuyen.thongTinGioiThieu ? this.props.data.nguoiDuocUyQuyen.thongTinGioiThieu : '';
      if (state.received !== true) {
        //loi o day, don cu chua co list tai lieu luat su
        this.props.data.listTaiLieuBangChungLuatSu.map((item, i) => {
          state.dsGiayUyQuyenLuatSu[i] = {
            ten: item.ten,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            required: item.required || false,
            tinhTrang: item.tinhTrangTaiLieu || '',
            taiLieuBangChungId: item.taiLieuBangChungId
          };
        });
        state.received = true;
      }
    }

    if (state.dsGiayUyQuyenLuatSu.length === 0) {
      state.dsGiayUyQuyenLuatSu[0] = {
        ten: 'Giấy ủy quyền',
        required: true,
        tenFile: '',
        duongDan: '',
        tinhTrang: '',
        taiLieuBangChungId: ''
      };
    }

    this.setState(state);
    this.props.onChange(state, true);
  }

  render() {
    return(
      <div className="items-form">
        <div className="rows">
          <Input label="Số thẻ" value={this.state.soTheLuatSu} onChange={this.handleChange.bind(this,'soTheLuatSu')} />
          <DatePicker label='Ngày cấp' value={this.state.ngayCapTheLuatSu} endDate={new Date()} onChange={this.handleChangeDate.bind(this, 'ngayCapTheLuatSu')} />
          <Input label="Nơi cấp" value={this.state.noiCapTheLuatSu} onChange={this.handleChange.bind(this, 'noiCapTheLuatSu')} />
          <Input className="col-40" value={this.state.thongTinGioiThieu} label="Thông tin giới thiệu" onChange={this.handleChange.bind(this, 'thongTinGioiThieu')} />
        </div>
        <div className="title">
          <div className="rows pl5 pr5">
            <h3>Danh sách tài liệu kèm theo</h3>
          </div>
        </div>
        <div className="items-form container-filedinhkem">
          <div className="rows">
            <div className="col-12">
              <ContainerFileDinhKem ref='containerFileDinhKem' type='TAI_LIEU_BO_SUNG' header = {header.addReception.danhSachBangChung} data={this.state.dsGiayUyQuyenLuatSu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} bindValidator={this} onSave={this.props.onSave}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ThongTinLuatSu.defaultProps = {
  onSave: false
}

export default validatable(ThongTinLuatSu);



// WEBPACK FOOTER //
// ./src/components/modules/reception/ThongTinLuatSu.jsx